/**
 * @generated SignedSource<<962a897d7d5b00ad7b7dfc15cbe4cb7f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LoginValidateEmailInput = {
  clientMutationId?: string | null | undefined;
  companyId: string;
  email: string;
};
export type LoginValidateEmailMutation$variables = {
  input: LoginValidateEmailInput;
};
export type LoginValidateEmailMutation$data = {
  readonly LoginValidateEmail: {
    readonly error: string | null | undefined;
    readonly fromEmail: boolean | null | undefined;
    readonly userExists: boolean | null | undefined;
  } | null | undefined;
};
export type LoginValidateEmailMutation = {
  response: LoginValidateEmailMutation$data;
  variables: LoginValidateEmailMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LoginValidateEmailPayload",
    "kind": "LinkedField",
    "name": "LoginValidateEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userExists",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fromEmail",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LoginValidateEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LoginValidateEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c21d66ee252d207ba0eaa8a40c99d66f",
    "id": null,
    "metadata": {},
    "name": "LoginValidateEmailMutation",
    "operationKind": "mutation",
    "text": "mutation LoginValidateEmailMutation(\n  $input: LoginValidateEmailInput!\n) {\n  LoginValidateEmail(input: $input) {\n    userExists\n    error\n    fromEmail\n  }\n}\n"
  }
};
})();

(node as any).hash = "6ea72040563e873ebb3c66503024cde5";

export default node;
